export default __webpack_public_path__ + "static/210528_夏日角色熱更預告_sc-0668d9bcefe71d4c40e6bf80bd3ad0f0.webp";